import classNames from 'classnames';
import { IconButton, IIconButtonProps } from 'components/buttons/IconButton';

interface IActionsFavoriteButtonProps extends Omit<IIconButtonProps, 'iconClassName' | 'ref'> {
  isFavorite?: boolean;
  disabled?: boolean;
}

const getClassName = (className?: string, isFavorite?: boolean) =>
  classNames(className, 'dp-actions-favorite-button', {
    'dp-actions-favorite-button--favorite': isFavorite,
  });

/**
 * Just a star icon
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function ActionsFavoriteButton({ className, isFavorite, disabled, ...props }: IActionsFavoriteButtonProps) {
  return (
    <IconButton
      className={getClassName(className, isFavorite)}
      iconClassName="dp-icon--favorite"
      iconSize="normal"
      disabled={disabled}
      {...props}
    />
  );
}
